import { reportingColors } from '../../../utils/colors'
import { Color, Rect, drawRect, parseColor } from '../../../utils/visualization'

export class HeatMapElement {
    private defaultColor: Color = parseColor(reportingColors.blue400)
    private color: Color
    private minOpacity0: number = 0.07
    private minOpacity1: number = 0.15
    private maxValue: number = 1
    private selected: boolean = false

    public value: number = 0
    public backgroundColor: Color
    public leftMargin: number = 0
    public topMargin: number = 0
    public rightMargin: number = 0
    public bottomMargin: number = 0
    public label: Date | null

    public mapRect: Rect

    constructor(mapRect: Rect) {
        this.mapRect = mapRect
        this.color = this.defaultColor
        this.backgroundColor = { red: 255, green: 255, blue: 255, alpha: 1 }
        this.value = 0
        this.maxValue = 1
        this.label = null
    }

    draw(ctx: CanvasRenderingContext2D) {
        let borderWidth = 0
        if (this.selected == true) {
            borderWidth = 2
        }
        drawRect(
            ctx,
            this.mapRect.x,
            this.mapRect.y,
            this.mapRect.width,
            this.mapRect.height,
            `rgba(${this.color.red}, ${this.color.green}, ${this.color.blue}, ${this.color.alpha})`,
            'black',
            borderWidth
        )
    }

    select() {
        this.selected = true
    }

    unSelect() {
        this.selected = false
    }

    isSelected(): boolean {
        return this.selected
    }

    updateValue(
        value: number,
        maxValue: number,
        label: Date,
        color: Color | null,
        selected: boolean = false
    ) {
        this.value = value
        this.maxValue = maxValue
        this.label = label
        this.selected = selected
        this.color = color || this.defaultColor

        let v = this.minOpacity0
        const brightness = this.value / this.maxValue

        if (brightness > 0) {
            v = this.minOpacity1 * (1 - brightness) + brightness
        }

        this.color.alpha = v
        this.color = {
            red: this.color.red,
            green: this.color.green,
            blue: this.color.blue,
            alpha: this.color.alpha,
        }
    }

    getCenter(): { x: number; y: number } {
        return {
            x: this.mapRect.x + this.mapRect.width / 2,
            y: this.mapRect.y + this.mapRect.height / 2,
        }
    }
}
